import {Pipe, PipeTransform} from '@angular/core';
import {CarDetails, ListingResult, ReportData} from '@shared/interfaces';
import {TitleCasePipe} from '@angular/common';

@Pipe({
  name: 'carTitle'
})
export class CarTitlePipe implements PipeTransform {

  transform(reportData: ReportData | ListingResult, hasCondition = true, hasTrim = true, isReport = true, hasLocation = false): string {
    const carDetails: CarDetails = reportData.carDetails;
    if (!carDetails) {
      return '';
    }
    let title = '';
    const titleCase = new TitleCasePipe();
    if (carDetails.condition && hasCondition) {
      title += titleCase.transform(carDetails.condition) + ' ';
    }
    if (carDetails.year) {
      if (carDetails.year instanceof Array) {
        title += [...carDetails.year].reverse().join(', ') + ' ';
      } else {
        title += carDetails.year + ' ';
      }
    }
    if (isReport && 'carDetails' in reportData) {
      if (!reportData.carDetails.specificationMode || reportData.carDetails.specificationMode === 'ymmt') {
        if (carDetails.make) {
          if (this.hasLowerCase(carDetails.make)) {
            title += titleCase.transform(carDetails.make) + ' ';
          } else {
            title += carDetails.make + ' ';
          }
        }
        if (carDetails.model) {
          if (this.hasLowerCase(carDetails.make)) {
            title += titleCase.transform(carDetails.model) + ' ';
          } else {
            title += carDetails.model + ' ';
          }
        }
        if (carDetails.trim && hasTrim) {
          title += carDetails.trim;
        }
      } else if (reportData.carDetails.specificationMode === 'bodyType') {
        if (carDetails.bodyType) {
          title += titleCase.transform(carDetails.bodyType) + 's';
        }
      }
    } else if (!isReport) {
      if (carDetails.make) {
        if (this.hasLowerCase(carDetails.make)) {
          title += titleCase.transform(carDetails.make) + ' ';
        } else {
          title += carDetails.make + ' ';
        }
      }
      if (carDetails.model) {
        if (this.hasLowerCase(carDetails.make)) {
          title += titleCase.transform(carDetails.model) + ' ';
        } else {
          title += carDetails.model + ' ';
        }
      }
      if (carDetails.trim && hasTrim) {
        title += carDetails.trim;
      }
    }

    if (hasLocation && 'geoInfo' in reportData) {
      if (reportData.geoInfo.city) {
        title += ` in ${reportData.geoInfo.city},`;
      }
      if (reportData.geoInfo.state) {
        title += ` ${reportData.geoInfo.state}`;
      }
      if (reportData.geoInfo.zipCode) {
        title += ` ${reportData.geoInfo.zipCode}`;
      }
    } else if (hasLocation && 'dealerDetails' in reportData) {
      if (reportData.dealerDetails.city) {
        title += ` in ${reportData.dealerDetails.city},`;
      }
      if (reportData.dealerDetails.state) {
        title += ` ${reportData.dealerDetails.state}`;
      }
      if (reportData.dealerDetails.zip) {
        title += ` ${reportData.dealerDetails.zip}`;
      }
    }

    return title.trim();
  }

  hasLowerCase(str: string) {
    return str.toUpperCase() !== str;
  }
}
